import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      align-items: center;
      justify-content: center;

      margin-bottom: 1rem;
    `;
  }};
`;
